/* eslint-disable @typescript-eslint/no-redeclare */
import { Static, Type } from '@sinclair/typebox';

export type JobInputParamsSchema = Static<typeof JobInputParamsSchema>;
export const JobInputParamsSchema = Type.Record(
  Type.String(),
  Type.Union([Type.Undefined(), Type.Unknown()]),
);
